import Box from '@mui/material/Box';
import { TabPanel } from '@mui/lab';
import { GridColDef } from '@mui/x-data-grid';
import { formatDate } from '../../../../../shared/utils/helpers/date';
import { formatCurrency } from '../../../../../shared/utils/helpers/numbers';
import Divider from '@mui/material/Divider';
import DataTable from '../../../../../shared/components/Table';
import { useEffect, useState } from 'react';
import { dup } from '../../../../../shared/types/nfe.ts';
import Typography from '@mui/material/Typography/Typography';
import { SelectAutoCompleteComponent } from '../../../../../shared/components/SelectAutoCompleteComponent';
import { SelectAutoCompleteOptions } from '../../../../../shared/types/selectAutoComplete';


const COLUMNS: GridColDef[] = [
    {
        field: 'cat',
        headerName: 'Categoria',
        headerAlign: 'center',
        align: 'center',
        width: 700,
    },
    {
        field: 'catValor',
        headerName: 'Valor',
        headerAlign: 'center',
        align: 'center',
        width: 200,
        valueGetter: (value) => formatDate(value),
    },
    {
        field: 'catPercentual',
        headerName: 'Percentual (%)',
        headerAlign: 'center',
        align: 'center',
        width: 200,
        valueGetter: (value) => formatCurrency(value, 2, 2)
    }
]

interface TabCategoriaProps {
    values: any,
    activeCategoriaSelected: any;
    CategoriaOptions: SelectAutoCompleteOptions[];
    handleAutoCompleteSelectedCategoria: (value: SelectAutoCompleteOptions) => void;
    handleSearchCategoria: (value: string, type: string) => void;
    duploClick?: boolean;
}

export const TabCategoria = ({
    values,
    activeCategoriaSelected,
    CategoriaOptions,
    handleAutoCompleteSelectedCategoria,
    handleSearchCategoria,
    duploClick
}: TabCategoriaProps) => {
    const [fats, setFats] = useState<dup[]>([])

    const handleFats = (dup: dup[]): dup[] => {
        if (dup) {
            if (dup?.length) {
                return dup.map((item: dup, index: number) => {
                    return { ...item, id: index }
                })
            } else {
                // @ts-ignore - .
                return [{ ...dup, id: 1 }]
            }
        }
        return []
    }

    useEffect(() => {
        setFats(handleFats(values?.nfeProc?.NFe?.infNFe?.cobr?.dup))
    }, [values?.nfeProc?.NFe?.infNFe?.cobr?.dup])

    return (
        <TabPanel value='2'>
            <form autoComplete='off' onSubmit={() => console.log('oi')} name='customer-detail'>
                <fieldset disabled={duploClick}>
                    <Box className='grid grid-cols-12 gap-7 pt-4'>
                        <SelectAutoCompleteComponent
                            label={'Categoria Financeira *'}
                            value={activeCategoriaSelected?.cfi_descricao ?? ''}
                            className={'col-span-6'}
                            name={'categoria.catFinanceiraId'}
                            options={CategoriaOptions}
                            handleSearch={(value: string) =>
                                handleSearchCategoria(value, 'categoria.catFinanceiraId')
                            }
                            onSelectValue={handleAutoCompleteSelectedCategoria}
                        />
                        <Box className='col-span-12 py-4 pt-4'>
                            <div className='flex justify-center'>
                                <Typography variant="h5" component="h2" className='col-span-6 gap-left-8'>
                                    Categorias
                                </Typography>
                            </div>
                            <Divider className={'col-span-12'} />
                            <DataTable
                                hideFooter={true}
                                height={'30vh'}
                                columns={COLUMNS}
                                rows={fats}
                                showFilter={false}
                                showButtonToXlsx={false}
                            />
                        </Box>
                    </Box>
                </fieldset>
            </form>
        </TabPanel>
    )
}